import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
import DataViewerModel from "../DataViewerModel.js"; // import DataViewerModel from '../DataViewerModel'
// const OLD_TYPE = 'molten.groupScreen.ViewerModel'
const TYPE = 'molten.dataViewers.LayoutModel';
const {
  t
} = I18N.ns('molten.dataViewers.layout.layoutModel');

/**
 * This represents one source of a filter - a search bar, or a table for example.
 * The FilterSourcesModel will use these to create a single query, as well as to 
 * manage saving the filter states. Metadata is for use by the source.
 */
function create(extra) {
  return {
    type: TYPE,
    version: 2,
    layout: 'vh',
    main1: null,
    // DataViewerModel.create( 'tableList', null ),
    main2: null,
    // DataViewerModel.create( 'map', null ),
    aux1: null,
    // top
    aux2: null,
    // bot
    aux3: null,
    // left
    aux4: null,
    // right
    topLeft: 'aux1',
    topRight: 'aux1',
    bottomLeft: 'aux2',
    bottomRight: 'aux2',
    showFilterBar: true,
    ...extra
  };
}
function c(key, model) {
  return model[key] == null ? null : key;
}

// showAll true is for the editor, showAll false is for use
function createGridTemplate(model, showAll = false) {
  const {
    // aux1, aux3, aux4, aux2, main1, main2,
    topLeft = 'aux1',
    topRight = 'aux1',
    bottomLeft = 'aux2',
    bottomRight = 'aux2',
    layout = 'vh'
  } = model;
  const m = model;
  const isHorz = layout[1] === 'h';
  const mtl = showAll ? 'main1' : 'main';
  const mtr = showAll ? isHorz ? 'main2' : 'main1' : 'main';
  const mbl = showAll ? isHorz ? 'main1' : 'main2' : 'main';
  const mbr = showAll ? 'main2' : 'main';
  const tv = showAll ? 'aux1' : c('aux1', m);
  const bv = showAll ? 'aux2' : c('aux2', m);
  const lv = showAll ? 'aux3' : c('aux3', m);
  const rv = showAll ? 'aux4' : c('aux4', m);
  const tlv = showAll ? topLeft || 'aux1' : c(topLeft, m);
  const trv = showAll ? topRight || 'aux1' : c(topRight, m);
  const blv = showAll ? bottomLeft || 'aux2' : c(bottomLeft, m);
  const brv = showAll ? bottomRight || 'aux2' : c(bottomRight, m);
  const l = lv || mtl;
  const r = rv || mbr;
  const tl = tlv || tv || lv || (showAll ? c(mtl, m) : 'main');
  const tr = trv || tv || rv || (showAll ? c(mtr, m) : 'main');
  const bl = blv || bv || lv || (showAll ? c(mbl, m) : 'main');
  const br = brv || bv || rv || (showAll ? c(mbr, m) : 'main');
  const t1 = tv || (showAll ? c(mtl, m) : 'main');
  const t2 = tv || (showAll ? c(mtr, m) : 'main');
  const b1 = bv || (showAll ? c(mbl, m) : 'main');
  const b2 = bv || (showAll ? c(mbr, m) : 'main');
  return `"${tl} ${t1} ${t2} ${tr}"
          "${l} ${mtl} ${mtr} ${r}"
          "${l} ${mbl} ${mbr} ${r}"
          "${bl} ${b1} ${b2} ${br}"`;
}
function createSettingsSetter(field) {
  return (model, settings) => {
    let curr = model[field];
    if (curr == null) {
      throw Error(t('error'));
    }
    if (typeof curr === 'string') {
      curr = DataViewerModel.create(curr, settings);
      return {
        ...model,
        [field]: curr
      };
    }
    return {
      ...model,
      [field]: {
        ...curr,
        settings
      }
    };
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('layout'),
  ...ModelUtil.createAllValue('aux1'),
  ...ModelUtil.createAllValue('aux2'),
  ...ModelUtil.createAllValue('aux3'),
  ...ModelUtil.createAllValue('aux4'),
  ...ModelUtil.createAllValue('main1'),
  ...ModelUtil.createAllValue('main2'),
  ...ModelUtil.createAllValue('topLeft'),
  ...ModelUtil.createAllValue('topRight'),
  ...ModelUtil.createAllValue('bottomLeft'),
  ...ModelUtil.createAllValue('bottomRight'),
  ...ModelUtil.createAllValue('showFilterBar', null, null, {
    defaultValue: true
  }),
  createGridTemplate,
  setAux1Settings: createSettingsSetter('aux1'),
  setAux2Settings: createSettingsSetter('aux2'),
  setAux3Settings: createSettingsSetter('aux3'),
  setAux4Settings: createSettingsSetter('aux4'),
  setMain1Settings: createSettingsSetter('main1'),
  setMain2Settings: createSettingsSetter('main2')
};